<template>
  <div>
    <div class="preview-title">
      <div>广告预览</div>
      <div class="preview-msg">{{ previewMsg[activeIndex - 1] }}</div>
      <div>
        <gj-button size="mini" icon="el-icon-arrow-left" @click="carouselOpt('prev')"></gj-button>
        <gj-button size="mini" icon="el-icon-arrow-right" @click="carouselOpt('next')"></gj-button>
      </div>
      <div class="tag">{{ activeIndex }} / 2</div>
    </div>
    <el-carousel ref="carousel" trigger="click" height="506px" width="538px" :autoplay="false" @change="change">
      <el-carousel-item>
        <div class="preview preview1">
          <video class="video" width="100%" ref="video1" :src="form.videoInfo.publishedMediaUrl" :controls="video.controls1" preload="metadata" webkit-playsinline="true">您的浏览器不支持播放视频。</video>
          <i class="el-icon-caret-right" v-if="!video.controls1" @click="play(1)"></i>
          <div class="commodity">
            <img class="img" :src="asins0.imageUrl" />
            <div class="info">
              <div class="sponsored">Sponsored</div>
              <div class="title">{{ asins0.title || "-"}}</div>
              <el-rate disabled :value="asins0.ratingQuantity || 0" show-score></el-rate>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="preview preview2">
          <div class="preview-content">
            <video class="video" width="100%" ref="video2" :src="form.videoInfo.publishedMediaUrl" :controls="video.controls2" preload="metadata" webkit-playsinline="true">您的浏览器不支持播放视频。</video>
            <i class="el-icon-caret-right" v-if="!video.controls2" @click="play(2)"></i>
            <div class="commodity">
              <img class="img" :src="asins0.imageUrl" />
              <div class="info">
                <div class="sponsored">Sponsored</div>
                <div class="title">{{ asins0.title || "-"}}</div>
                <el-rate disabled :value="asins0.ratingQuantity || 0" show-score></el-rate>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
    name: "ad-preview",
    inject: [ "getForms" ],
    data() {
      return {
        form: {},
        video: {
          controls1: false,
          controls2: false,
        },
        previewMsg: [
          "搜索结果上方：移动设备广告",
          "搜索结果上方：桌面设备",
        ],
        activeIndex: 1
      }
    },
    computed: {
      asins0() {
        return (this.form.asinsItem && this.form.asinsItem.length != 0 && this.form.asinsItem[0]) || {}
      }
    },
    methods: {
      play(type) {
        this.video[`controls${type}`] = true
        this.$refs[`video${type}`].play()
      },
      // 手动切换
      carouselOpt(opt) {
        this.$refs.carousel[opt]()
      },
      change() {
        this.activeIndex = Number(this.$refs.carousel.activeIndex) + 1
      }
    },
    created() {
      let { creative } = this.getForms()
      this.form = creative
    },
}
</script>

<style scoped lang="scss">
@mixin preview-style($width, $height, $top, $left) {
  width: $width;
  height: $height;
  top: $top;
  left: $left;
}
.preview-title {
  padding: 0 16px;
  display: flex;
  align-items: center;
  line-height: 1;
  height: 42px;
  font-size: 12px;
  border: 1px solid #eee;
  .preview-msg {
    width: 200px;
    text-align: center;
    margin: 0 16px;
    padding: 7px 0;
    border: 1px solid #eee;
    border-radius: 3px;
    color: #969696;
    transform: scale(.95);
  }
  .tag {
    color: #969696;
    padding-left: 16px;
    transform: translateY(7px);
  }
  /deep/.el-button {
    width: 0;
    height: 25px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
.preview {
  height: 100%;
  position: relative;
  background-size: 100%;
  .preview-content {
    position: absolute;
    background: #F6F6F8;
    font-size: 12px;
  }
  video {
    object-fit:fill
  }
  &.preview1 {
    background-image: url("~@/assets/images/ad/preview1.png");
    position: relative;
    .el-icon-caret-right {
      font-size: 66px;
      position: absolute;
      top: 230px;
      left: 50%;
      transform: translateX(-50%);
      color: #ccc;
    }
    .video {
      position: absolute;
      width: 386px;
      height: 152px;
      top: 196px;
      left: 94px;
      background: #F6F6F8;;
    }
    .commodity {
      position: absolute;
      width: 386px;
      height: 152px;
      top: 348px;
      left: 94px;
      display: flex;
      .img {
        width: 100px;
        height: 100px;
        margin: 12px;
      }
      .info {
        padding-top: 12px;
        padding-right: 12px;
        font-size: 12px;
        color: #666666;
        flex: 1;
        .sponsored {
          display: inline-block;
          transform: scale(.85) translateX(-7px);
        }
        .title {
          width: 100%;
          margin-bottom: 5px;
          overflow: hidden;
          word-break:break-all;
          display: -webkit-box;//将元素设为盒子伸缩模型显示
          -webkit-box-orient: vertical;//伸缩方向设为垂直方向
          -webkit-line-clamp: 2;//超出3行隐藏，并显示省略号
        }
      }
    }
  }
  &.preview2 {
    background-image: url("~@/assets/images/ad/preview3.png");
    display: flex;
    align-items: center;
    justify-content: center;
    .el-icon-caret-right {
      position: absolute;
      top: 50%;
      left: 100px;
      font-size: 30px;
      transform: translateY(-50%);
      color: #CDCDCD;
    }
    .preview-content {
      padding: 0 12px;
      display: flex;
      width: 536px;
      height: 115px;
      align-items: center;
      background: #FFFFFF;
      .video {
        width: 225px;
        height: 102px;
        background: #F6F6F8;
      }
      .commodity {
        flex: 1;
        display: flex;
        .img {
          width: 100px;
          height: 100px;
          margin: 12px;
        }
        .info {
          padding-top: 12px;
          padding-right: 12px;
          font-size: 12px;
          color: #666666;
          flex: 1;
          .sponsored {
            display: inline-block;
            transform: scale(.85) translateX(-7px);
          }
          .title {
            width: 100%;
            margin-bottom: 5px;
            overflow: hidden;
            word-break:break-all;
            display: -webkit-box;//将元素设为盒子伸缩模型显示
            -webkit-box-orient: vertical;//伸缩方向设为垂直方向
            -webkit-line-clamp: 2;//超出3行隐藏，并显示省略号
          }
        }
      }
    }
  }
}
</style>